import React from 'react'
import { autorun } from 'mobx'
import { observer, inject } from 'mobx-react'
import { Switch, Route, Router } from 'react-router-dom'
import intl from 'react-intl-universal';
import { isMobile } from 'Utils/device'
//import {loadApm} from './ApmTrace';
import {
  getQueryVariable,
  outputVersion,
  loadVconsole,
  isCNDomainByServerless,
} from 'Utils/utils';
import { COLLABORATION_MODE, COMMON_MODE } from '@/constants/app.constant'
import { store } from './store/store.index'
import Mainlayout from './routes/index';
//import { ViewerPage } from './pages/index';
//import {HeaderContainer} from './components/index'
import {LoadingPage, EsignToolsPage, ESignCNEvidenceToolPage, ESignCNAuditTrail} from 'Pages/index';
import PrivateDrives from './components/private_drives/PrivateDrives'

import { ConfigProvider, Modal, Empty } from 'antd';

import moment from "moment"
import "moment/locale/zh-cn"
import "moment/locale/ja"
import "moment/locale/it"
import "moment/locale/ko"
import "moment/locale/de"
import "moment/locale/fr"
import "moment/locale/es"
import "moment/locale/nl"

// import zh_CN from 'antd/lib/locale-provider/zh_CN';
// import en_US from 'antd/lib/locale-provider/en_US';
// import ja_JP from 'antd/lib/locale-provider/ja_JP';
// import it_IT from 'antd/lib/locale-provider/it_IT';
// import ko_KR from 'antd/lib/locale-provider/ko_KR';
// import de_DE from 'antd/lib/locale-provider/de_DE';
// import fr_FR from 'antd/lib/locale-provider/fr_FR';
// import es_ES from 'antd/lib/locale-provider/es_ES';
// import nl_NL from 'antd/lib/locale-provider/nl_NL';

// import { loadWebMonitor } from "./lib/web-monitor/web-monitor";
// import { createMonitorConfig } from "./app.config";
import './common.scss';
import './short.scss';
import './fwIcon';
import './online_overwrite_antd/index.scss'
import wrapDialog from '@/routes/wrapperDialog';
import { FOXITWEBSDK_URLS } from './api/constants';
import ESignCNWebContainer from 'Pages/eSignCNWebContainer';

//addLocaleData([...en, ...zh]);
const langs = ['zh','ja', 'ko', 'de', 'fr', 'it', 'es', 'nl'];

const momentIntl = {
  zh: 'zh-cn',
  en: 'en',
  ja: 'ja',
  ko: 'ko',
  de: 'de',
  fr: 'fr',
  it: 'it',
  es: 'es',
  nl: 'nl',
}
const customizeRenderEmpty = () => (
  <Empty description={intl.formatMessage({ id: 'NoData' })} image={Empty.PRESENTED_IMAGE_SIMPLE} />
);
// moment.locale("ja")
// output current code version
outputVersion();
//import darkTheme from "./themes/dark.json";
//console.log('onlineApp')
let isBlack = getQueryVariable('isBlack')==1;
if (isBlack) {
  document.querySelector('html').classList.add('fv__ui-black-theme');
  import('./styles/dark.json').then((darkTheme) => {
    //console.log('===>>> ~ import ~ darkTheme', darkTheme);
    window.less.modifyVars(darkTheme);
  })
}

// 使用的allInOne.css引入
let style = document.createElement('link')
if (process.env.NODE_ENV == 'development') {
  style.href = isMobile?FOXITWEBSDK_URLS.addonsMobileStylePC:FOXITWEBSDK_URLS.addonsStylePC;
}else{
  style.href = isMobile?FOXITWEBSDK_URLS.addonsMobileStylePC:FOXITWEBSDK_URLS.addonsStylePC;
}
document.body.appendChild(style);
style.rel = "stylesheet"
style.type = "text/css"

//loadApm();
//TODO FOXIT 福软异常捕获
// loadWebMonitor(window, createMonitorConfig());
loadVconsole();
//const MainlayoutComponent = Mainlayout;

// To clean Modal transition对话框样式默认值
if (Modal && Modal.defaultProps) {
  Modal.defaultProps['maskClosable'] = false;
  Modal.defaultProps['transitionName'] = 'none';
  Modal.defaultProps['maskTransitionName'] = 'none';
  Modal.defaultProps['closeIcon'] = <i className={' closeIcon fv__icon-layer-close'}></i>
  Modal.defaultProps['zIndex'] = 1050;
  !isMobile && (Modal.defaultProps['centered'] = true);
}
const isCollabURL = ()=>{
    const reviewSessionID = getQueryVariable('reviewSessionID')
    const fileLink = getQueryVariable('docUrl')
    const fileName = getQueryVariable('fileName')
    return reviewSessionID && fileLink && fileName
  }
if(isCollabURL()){
    const ele = document.createElement('link');
    ele.rel = "stylesheet";
    ele.href = FOXITWEBSDK_URLS.UIExtension.replace("full.js","css");
    document.head.appendChild(ele);
}


const App = inject("appStore", "userStore", "historyStore","esignCnStore")(observer((/* props */) => {
  const { lang, full } = store.appStore.lng;
  const history = store.historyStore.history;
  const messages = store.appStore.allLangs[lang];
  const { currentMode } = store.appStore
  const { inTeamsApp } = store.teamsAppStore
  if (process.env.NODE_ENV == 'development') {
    window.__intl__ = intl;
    window.__lang_messages__ = messages;
  }
  store.appStore.loadLocales({ lang, full });
  autorun(() => {
    let node = document.querySelector('html');

    if (currentMode === COLLABORATION_MODE) {
      node.setAttribute('online-mode', 'collaboration')
    } else if (currentMode === COMMON_MODE) {
      node.setAttribute('online-mode', 'common')
    }
    if (inTeamsApp) {
      node.setAttribute('teams-app', 'true')
    }

    node.setAttribute('online-lang', lang);
    node.setAttribute('lang', lang);
  });
  store.appStore.updateAppTitle();
  // store.appStore.updateHtmlInfo();

  let momentLocale = 'zh';
  if(langs.includes(lang)){
    momentLocale = momentIntl[lang];
  }
  moment.locale(momentLocale.toLowerCase())

  // if (store.userStore.hasSignIn) {
  //   collaborationService.getUserToken()
  // } else {
  //   store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS, () => {
  //     collaborationService.getUserToken()
  //   });
  // }

  let routes = [
    {
      path: '/login/:token/:targetUrl',
      component: Mainlayout,
      exact: true
    },
    {
      path: '/login/success',
      component: Mainlayout,
      exact: true
    },
    {
      path: '/logout/success',
      component: Mainlayout,
      exact: true
    },
    {
      path: '/test-case',
      component: Mainlayout,
      exact: true
    },
    {
      path: '/drives',
      component: PrivateDrives
    },
    {
      path: '/loading',
      component: LoadingPage
    },
    {
      path: '/esigncn-web-container',
      component: ESignCNWebContainer
    }
  ]

  if (isCNDomainByServerless()) {
    const eSignCNToolRoutes = [
      {
        path: "/internal_identity_verify",
        component: EsignToolsPage
      },
      {
        path: "/external_extract_tool",
        component: ESignCNEvidenceToolPage
      },
      {
        path: "/eSignCN_signing_report",
        component: ESignCNAuditTrail
      }
    ]
    routes = [...routes, ...eSignCNToolRoutes]
  }

  routes.push({
    path: "",
    component: Mainlayout
  })

  const renderRoutes = (routes) => {
     return routes.map((route, index) => {
        return (
          <Route exact={route.exact} path={route.path} component={route.component} key={index}></Route>
        )
     })
  }

  return (
    <ConfigProvider renderEmpty={customizeRenderEmpty} autoInsertSpaceInButton={false}>
      <Router history={history}>
        {wrapDialog(<Switch>
          {renderRoutes(routes)}
        </Switch>)}
      </Router>
    </ConfigProvider>
  );
}))

export default App;
